import { Tabs } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function URLTabs({activeKey, defaultActiveKey, size, onChange, items, ...props}) {
  const { hash } = useLocation()
  const navigate = useNavigate()
  const [tab, setTab] = useState(hash || defaultActiveKey)

  const hashed = useCallback((val) => !val ? '#' : (val.startsWith('#') ? val.toLowerCase() : `#${val.toLowerCase()}`), [])
  const hashedActiveKey = useMemo(() => hashed(activeKey), [activeKey, hashed])
  const hashedDefaultKey= useMemo(() => hashed(defaultActiveKey), [defaultActiveKey, hashed])
  const tabItems = useMemo(() => (items ?? []).map((item) => ({ ...item, key: hashed(item.key) })), [items, hashed])

  useEffect(() => {
    if (tabItems.find(({ key }) => key === hash.toLowerCase())) {
      setTab(hash.toLowerCase())
      return
    }
    navigate(hashedDefaultKey, { replace: true })
  }, [hash, tabItems, hashedDefaultKey, navigate])

  useEffect(() => {
    if (hashedActiveKey !== '#') {
      if (tabItems.find(({ key }) => key === hashedActiveKey)) {
        setTab(hashedActiveKey)
        navigate(hashedActiveKey, { replace: true })
        return
      }
      setTab(hashedDefaultKey)
      navigate(hashedDefaultKey, { replace: true })
    }
  }, [hashedActiveKey, tabItems, hashedDefaultKey, navigate])

  return (
    <Tabs
      {...props}
      activeKey={tab}
      defaultActiveKey={defaultActiveKey}
      size={size}
      items={tabItems}
      onChange={(key) => {
        setTab(key)
        navigate(key, { replace: true })
        onChange?.(key)
      }}
    />
  )
}